import { TAdLinkType } from 'models/adLinks'
import { transliterate } from 'components/seo-pages/SeoPageForm/utils/seoValidation'

export const adLinkTypeLabels: Record<TAdLinkType, string> = {
  blogger: 'Блогер',
  partner: 'Партнёр',
  offline: 'Офлайн'
}

export const adLinkTypeColors: Record<TAdLinkType, string> = {
  blogger: 'magenta',
  partner: 'blue',
  offline: 'default'
}

export const AD_LINK_CODE_MAX_LENGTH = 40

// Те же правила, что у кода на бэкенде: латиница и цифры через дефис или подчёркивание
export const AD_LINK_CODE_REGEX = /^[a-z0-9]+(?:[-_][a-z0-9]+)*$/

export const codeFromName = (name: string) =>
  transliterate(name)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .slice(0, AD_LINK_CODE_MAX_LENGTH)
    .replace(/^-+|-+$/g, '')
